import { useEffect, useState } from "react";
import { cachedLightImageHitRect, loadLightImageHitRect, type C1_LightImageHitRect } from "../plan/C1_LightImageHitRectCache";

/** Fits the visible light graphic, excluding transparent margins, into the editor's icon slot. */
export function C1_LightProductImage({ src, alt = "" }: { src: string; alt?: string }) {
  const [measured, setMeasured] = useState<{ src: string; bounds?: C1_LightImageHitRect }>();
  useEffect(() => {
    let active = true;
    void loadLightImageHitRect(src).then(bounds => {
      if (active) setMeasured({ src, bounds });
    }).catch(() => {
      if (active) setMeasured({ src });
    });
    return () => { active = false; };
  }, [src]);
  const bounds = cachedLightImageHitRect(src) ?? (measured?.src === src ? measured.bounds : undefined);
  if (!bounds) return <img src={src} alt={alt} />;
  return (
    <svg viewBox={`${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`}
      preserveAspectRatio="xMidYMid meet" role={alt ? "img" : undefined}
      aria-label={alt || undefined} aria-hidden={alt ? undefined : true}>
      <image href={src} width={bounds.imageWidth} height={bounds.imageHeight} />
    </svg>
  );
}
